import React from 'react'
import DefaultsContainer from './DefaultsContainer'

const Defaults = () => <DefaultsContainer data-test="component-tradeIn-defaults" />

export default Defaults
